import { PaperPlaneRightIcon, XIcon} from '@phosphor-icons/react';
import React, { useState, useRef, useEffect } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import useOnEscape from 'hooks/useOnEscape';

export default function ChatInput({
    onMessageSubmit,
    form
}) {

    const [tagsPopup, setTagsPopup] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [message, setMessage] = useState('');
    const textareaRef = useRef(null);

    const tags = [{
        id: 1,
        name: 'Fatture',
        type: 'documents'
    }, {
        id: 2,
        name: 'Contratti',
        type: 'documents'
    }, {
        id: 3,
        name: 'Progetti',
        type: 'documents'
    }, {
        id: 4,
        name: 'Clienti',
        type: 'clients'
    }, {
        id: 5,
        name: 'Fornitori',
        type: 'clients'
    }, {
        id: 6,
        name: 'Documenti',
        type: 'documents'
    }, {
        id: 7,
        name: 'Email',
        type: 'clients'
    }, {
        id: 8,
        name: 'Comunicazioni',
        type: 'clients'
    }, {
        id: 9,
        name: 'Prodotti',
        type: 'documents'
    }]

    const tagTypes = [...new Set(tags.map(tag => tag.type))];

    useOnEscape(tagsPopup, () => setTagsPopup(false));

    const handleSubmit = (e) => {
        e.preventDefault();
        if (message.trim()) {
            const formData = new FormData(form.current);
            onMessageSubmit(formData);
            setMessage('');
            textareaRef.current?.focus();
        }
    };

    useEffect(() => {
        textareaRef.current?.focus();
    }, []);

    return (
        <>
            <div className='absolute bottom-0 left-0 right-0 flex flex-col justify-end pointer-events-none'>
                <div className='w-full bg-gradient-to-t from-white via-white to-transparent h-32 pointer-events-none'></div>

                <div className='bg-white w-full pointer-events-auto'>
                    <form
                        ref={form}
                        onSubmit={handleSubmit}
                        className='relative w-full max-w-3xl mx-auto px-4 md:px-6 pb-[max(1.5rem,env(safe-area-inset-bottom))]'
                    >
                        <div className='relative bg-white border border-black/10 rounded-3xl shadow-lg hover:shadow-xl transition-shadow duration-200 focus-within:border-black/20'>
                            {selectedTags.length > 0 && (
                                <div className='flex flex-wrap gap-2 px-4 pt-4'>
                                    {selectedTags.map((tag, index) => (
                                        <button
                                            type="button"
                                            key={index}
                                            aria-label={`Rimuovi tag ${tag}`}
                                            className='bg-black/5 hover:bg-black/10 text-black text-sm px-3 py-1.5 rounded-full flex items-center gap-2 cursor-pointer transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-1'
                                            onClick={() => setSelectedTags(selectedTags.filter(t => t !== tag))}
                                        >
                                            {tag}
                                            <XIcon size={14} weight="bold" />
                                        </button>
                                    ))}
                                </div>
                            )}

                            <div className='flex items-end gap-2 px-4 py-3'>
                                <TextareaAutosize
                                    ref={textareaRef}
                                    name="message"
                                    id="message"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Scrivi un messaggio..."
                                    className="flex-1 bg-transparent text-black placeholder:text-muted focus:outline-none resize-none text-base leading-relaxed max-h-[200px]"
                                    minRows={1}
                                    maxRows={8}
                                    style={{
                                        minHeight: 34
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            handleSubmit(e);
                                        }
                                    }}
                                />

                                <div className='flex items-center gap-2 pb-1'>
                                    <button
                                        type="submit"
                                        aria-label="Invia messaggio"
                                        disabled={!message.trim()}
                                        className={`touch-target inline-flex items-center justify-center p-2 rounded-full transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-2 ${
                                            message.trim()
                                                ? 'bg-black hover:bg-black/90 cursor-pointer'
                                                : 'bg-black/10 cursor-not-allowed'
                                        }`}
                                    >
                                        <PaperPlaneRightIcon
                                            size={20}
                                            weight="fill"
                                            className={message.trim() ? 'text-white' : 'text-black/30'}
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className='text-center mt-2 text-xs text-muted'>
                            Premi Invio per inviare, Shift+Invio per andare a capo
                        </div>
                    </form>
                </div>
            </div>

            <div className={`fixed z-[var(--z-modal)] flex top-0 left-0 lg:left-[320px] right-0 bottom-0 items-center justify-center transition-all backdrop-blur-sm ${tagsPopup ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>

                <div className='absolute top-0 left-0 right-0 bottom-0 bg-black/20 transition-all duration-300 ease-in-out flex items-center justify-center' onClick={() => setTagsPopup(false)}></div>


                <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="tags-dialog-title"
                    className={`relative max-w-[90vw] w-full max-w-[550px] max-h-[87vh] bg-white border border-black/10 shadow-2xl rounded-2xl transition-all duration-300 ease-out-quint flex flex-col ${tagsPopup ? 'translate-y-0 scale-100' : 'translate-y-3 scale-95'}`}
                >
                    <div className='w-full border-b border-black/6 px-6 py-4 flex justify-between items-center'>
                        <p id="tags-dialog-title" className='font-medium text-lg'>Scegli i tag di ricerca</p>

                        <button type="button" aria-label="Chiudi" className='p-2 hover:bg-black/5 rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow focus-visible:ring-offset-2' onClick={() => setTagsPopup(false)}>
                            <XIcon size={24} className='text-black' weight="bold" />
                        </button>
                    </div>

                    <div className='flex-1 w-full overflow-y-auto'>
                        <div className='flex'>
                            {tagTypes?.map((tagType, index) => {
                                return (
                                    <div className={`flex-1 p-5 border-r border-black/6 last:border-r-0`} key={index}>
                                        <p className='text-black/50 pb-3 font-medium text-sm uppercase tracking-wide'>{tagType.charAt(0).toUpperCase() + tagType.slice(1)}</p>
                                        <div className='space-y-2'>
                                            {tags?.filter(tag => tag.type === tagType)?.map((tag) => {
                                                const isSelected = selectedTags.includes(tag.name);
                                                return (
                                                    <button
                                                        type="button"
                                                        key={tag.id}
                                                        role="checkbox"
                                                        aria-checked={isSelected}
                                                        className='w-full flex items-center justify-start gap-3 text-sm py-2 px-2 rounded-lg hover:bg-black/5 cursor-pointer transition-colors text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow'
                                                        onClick={() => {
                                                            if (isSelected) {
                                                                setSelectedTags(selectedTags.filter(t => t !== tag.name));
                                                            } else {
                                                                setSelectedTags([...selectedTags, tag.name]);
                                                            }
                                                        }}
                                                    >
                                                        <div className={`w-5 h-5 rounded flex items-center justify-center border-2 transition-all ${
                                                            isSelected
                                                                ? 'bg-black border-black'
                                                                : 'bg-white border-black/20 hover:border-black/40'
                                                        }`}>
                                                            {isSelected && (
                                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                    <path d="M2 6L5 9L10 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                </svg>
                                                            )}
                                                        </div>
                                                        <span className='text-black'>{tag.name}</span>
                                                    </button>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className='w-full border-t border-black/6 p-4'>
                        <button
                            className='w-full bg-black hover:bg-black/90 text-white py-3 rounded-xl font-medium transition-colors'
                            onClick={() => setTagsPopup(false)}
                        >
                            Conferma selezione
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
